import { Box, Stack, Text, Title } from '@mantine/core';

import { accentFill } from '../theme';

interface PageTitleProps {
  title: string;
  description?: string;
}

/**
 * Единый заголовок раздела: верхний регистр с разрядкой и короткая синяя
 * черта под ним — тот же приём, что и в заголовках на сайте коллектива.
 */
export function PageTitle({ title, description }: PageTitleProps) {
  return (
    <Stack gap="xs">
      <Title
        order={1}
        fz={{ base: 24, sm: 28 }}
        c="graphite.9"
        style={{ textTransform: 'uppercase', letterSpacing: '0.08em' }}
      >
        {title}
      </Title>

      <Box w={44} h={3} bg={accentFill} style={{ borderRadius: 2 }} />

      {description !== undefined && (
        <Text c="graphite.6" size="sm" maw={620} mt={4}>
          {description}
        </Text>
      )}
    </Stack>
  );
}
